import config from '../../../config'
import { EnrolmentFormMedicalData as EnrolmentFormMedicalDataPompeuFabra } from './medicaldata.pompeufabra';
import { EnrolmentFormMedicalData as EnrolmentFormMedicalDataGeneric } from './medicaldata.generic';

export default function EnrolmentFormPersonalData(props)
{
  switch(config.cid)
  {
     // Pompeu Fabra
   case 'a8020620': 
    return EnrolmentFormMedicalDataPompeuFabra(props)

   default: 
    return EnrolmentFormMedicalDataGeneric(props)
  }
}